import {
  PromotionEffectType,
  type BuyXGetYEffect,
  type AutomaticDiscountEffect,
  type BasketResponseData,
  type BasketItem,
  type Product,
  type Variant,
} from '@scayle/storefront-nuxt'

export const getBorderColorStyle = (color?: string) => {
  const fallbackColor = '#757575'
  return { borderColor: color || fallbackColor }
}

export const isBuyXGetYType = (promotion?: Promotion | null) => {
  return promotion?.effect?.type === PromotionEffectType.BUY_X_GET_Y
}

export const getBasketFreeGift = (
  basketItems: BasketItem<Product, Variant>[],
): BasketItem<Product, Variant> | undefined =>
  basketItems.find(
    (i) => i.promotion?.effect.type === PromotionEffectType.BUY_X_GET_Y,
  )

export const isAutomaticDiscountType = (promotion?: Promotion | null) => {
  return promotion?.effect?.type === PromotionEffectType.AUTOMATIC_DISCOUNT
}

export const getVariantIds = (promotion?: Promotion | null): number[] => {
  if (!promotion) {
    return []
  }
  const { additionalData } = promotion.effect as BuyXGetYEffect
  return additionalData.variantIds
}

export const getAdditionalData = (
  promotion?: Promotion | null,
): AutomaticDiscountEffect['additionalData'] | undefined => {
  if (!isAutomaticDiscountType(promotion) || !promotion) {
    return
  }
  const { additionalData } = promotion.effect as AutomaticDiscountEffect
  return additionalData
}

export const getBasketTotalWithoutPromotions = (
  basket?: BasketResponseData,
) => {
  if (!basket) {
    return 0
  }

  const promotionReductions = basket.cost.appliedReductions
    .filter(({ category }) => category === 'promotion')
    .reduce((acc, { amount }) => acc + amount.absoluteWithTax, 0)

  return basket.cost.withTax + promotionReductions
}
